const subjectColors = [
  {
    subject: "Physics",
    colorCode: "#F8AAAA",
  },
  {
    subject: "Chemistry",
    colorCode: "#FDC88E",
  },
  {
    subject: "Maths",
    colorCode: "#7CDCDF",
  },
  {
    subject: "Mathematics",
    colorCode: "#7CDCDF",
  },
  {
    subject: "Biology",
    colorCode: "#A5CBEE",
  },
  {
    subject: "Geography",
    colorCode: "#A7B3FA",
  },
  {
    subject: "History",
    colorCode: "#FEB093",
  },
  {
    subject: "Economics",
    colorCode: "#C297D4",
  },
  {
    subject: "Overall performance",
    colorCode: "#008DC4",
  },
  {
    subject: "Political science",
    colorCode: "#7CD1C2",
  },
  {
    subject: "Mental Ability",
    colorCode: "#8FC0C1",
  },
  {
    subject: "Botany",
    colorCode: "#94BF66",
  },
  {
    subject: "Zoology",
    colorCode: "#7A8295",
  },
  {
    subject: "Social Science",
    colorCode: "#E6BA85",
  },
  {
    subject: "English",
    colorCode: "#E080BB",
  },
  {
    subject: "General Knowledge",
    colorCode: "#E4A1A3",
  },
];
export { subjectColors };
